import { createSlice } from "@reduxjs/toolkit";
import apiClient from "../api/apiClient";

const initialState = {
  token: null,
  userType: null,
  role: null, // from login API ("A" admin, "P" user, "S" seller, "F" affiliate)
  isLoggedIn: false,
  user: null,
  userid: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, { payload }) => {
      state.token = payload.token;
      state.userType = payload.userType;
      state.role = payload?.role;
      state.isLoggedIn = true;
      state.userid = payload.userid;
    },
    // Only update userType (e.g. from /register/{id}/ profile API). Role is set once at login and never overwritten here.
    updatelogin: (state, { payload }) => {
      if (payload.userType !== undefined) state.userType = payload.userType;
    },

    logout: (state) => {
      state.token = null;
      state.isLoggedIn = false;
      state.user = null;
      state.userType = null;
      state.role = null;
      state.userid = null;
    },

    setUser: (state, { payload }) => {
      state.user = payload;
    },
  },
});

export const fetchUser = () => async (dispatch) => {
  try {
    const { data } = await apiClient.get("/users/my-info");

    if (data) {
      dispatch(authSlice.actions.setUser(data?.result)); // Dispatch the action to set the user data
    }
  } catch (e) {
    console.e("Error fetching user data:", e);
  }
};

// Action creators are generated for each case reducer function
export const { login, logout, updatelogin } = authSlice.actions;

export default authSlice.reducer;
